module.exports = __webpack_public_path__ + "static/media/WEBnegro_22.8014c06b.png";